import React, {Fragment} from 'react'
const CustomError = ({error, className}) => {
  if (error) {
    let messages = null;
    if (typeof error === 'string' || error instanceof String) {
      messages = [error];
    } else {
      messages = [error.message].flat();
    }
    const htmlRegex = /<[a-z][\s\S]*>/i;

    return <div className={`invalid-feedback ${className || ""}`}>
      {messages.map((k, v) => {
        return <Fragment key={v} >
          {htmlRegex.test(k) ?
            <div dangerouslySetInnerHTML={{ __html: k }} ></div>
            :
            k
          }
          <br/>
        </Fragment>
      })}
    </div>
  }

  return null
}

export default CustomError;
